import $ from "jquery";

$(document).on("turbolinks:load", () => {
  $(".notification__close").on("click", (e) => {
    e.preventDefault();
    $(e.target).closest(".flash-message").slideUp();
  });
});
